import React, { useEffect, useState } from "react";
import { Divider, Typography, makeStyles } from "@material-ui/core";
import { useQuery, useMutation, useLazyQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";

import { Card, CardContent, CardActions } from "../../components/Card";
import Grid from "../../components/Grid";
import Text from "../../components/Text";
import Button from "../../components/Button";
import PageItem from "../../components/PageItem";
import Table from "../../components/Table";
import { useAlert } from "../../components/Alert";

const GET_CUSTOMER = gql`
  query customer($id: Int!) {
    customer(id: $id) {
      id
      franchiseStore {
        id
        name
      }
      salesperson {
        id
        fullName
      }
      serialNumber
      customerType
      source
      willingness
      address
      joinCourseDeposit
      joinCourseDate
      franchiseDeposit
      franchiseDate
      remark
      customerInfo {
        id
        fullName
        gender
        mobile1
        mobile2
        line
        weChat
        email
      }
      customerDemand {
        id
        transfer
        demandPriceFrom
        demandPriceTo
        demandLandPingFrom
        demandLandPingTo
        demandBuildPingFrom
        demandBuildPingTo
        caseName
        floor
        elevator
        houseStatus
        parkingSpace
        administrator
        room
        livingroom
        bathroom
        managementFee
        overview
      }
    }
  }
`;

export default function CustomerDataTable({
  simulationQuery,
  onChangeSelect = () => {},
}) {
  const Alert = useAlert();
  const useStyles = makeStyles({
    DocumentContainerRow: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    DocumentContainerButtonEnd: {
      display: "flex",
      justifyContent: "flex-end",
    },
    DocumentContainerBetween: {
      alignItems: "center",
      justifyContent: "space-between",
    },
  });
  const classes = useStyles();
  const [newData, setNewData] = useState({
    page: 1,
    pageMax: null,
    pageSize: 10,
    pageArray: [],
  });

  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }

  const [getCustomer, { data, loading }] = useLazyQuery(GET_CUSTOMER, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    onError(error) {
      Alert.alert("通知", `${error}`, [
        {
          text: "確定",
          type: "ok",
        },
      ]);
    },
  });

  useEffect(() => {
    if (simulationQuery.id) {
      getCustomer({ variables: { id: simulationQuery.id } });
    }
  }, [simulationQuery]);

  return (
    <Card>
      <CardContent>
        <Grid container spacing={1}>
          <Grid
            xs={6}
            sm={2}
            item
            classes={{ root: classes.DocumentContainerRow }}
          >
            <Typography color="primary">分店:</Typography>
            <Typography></Typography>
          </Grid>
          <Grid
            xs={6}
            sm={2}
            item
            classes={{ root: classes.DocumentContainerRow }}
          >
            <Typography color="primary">客戶屬性:</Typography>
            <Typography>{simulationQuery?.attributes}</Typography>
          </Grid>
          <Grid
            xs={6}
            sm={2}
            item
            classes={{ root: classes.DocumentContainerRow }}
          >
            <Typography color="primary">客戶編號:</Typography>
            <Typography></Typography>
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardContent>
        <Grid
          container
          spacing={1}
          classes={{ root: classes.DocumentContainerBetween }}
        >
          <Typography style={{ fontSize: 25 }}>客戶資料</Typography>
          <Grid
            xs={12}
            sm={4}
            item
            classes={{ root: classes.DocumentContainerButtonEnd }}
          >
            {/* <Button
              size="small"
              color="primary"
              variant="contained"
              fullWidth
              onPress={() => {}}
            >
              發送簡訊
            </Button> */}
            {"\u2002"}
            {/* <Button
              size="small"
              color="primary"
              variant="contained"
              fullWidth
              onPress={() => {}}
            >
              設定優惠
            </Button> */}
            {"\u2002"}
            {Boolean(simulationQuery) && (
              <Button
                size="small"
                color="primary"
                variant="contained"
                fullWidth
                onPress={() => {
                  changeData("edit", true, true);
                  onChangeSelect(simulationQuery);
                }}
              >
                編輯客戶
              </Button>
            )}
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardContent>
        <Grid xs={6} sm={2} item>
          <Typography>客戶(一)</Typography>
        </Grid>
        <Grid container spacing={1}>
          <Grid
            xs={6}
            sm={3}
            item
            classes={{ root: classes.DocumentContainerRow }}
          >
            <Typography color="primary">名字:</Typography>
            <Typography></Typography>
          </Grid>
          <Grid
            xs={6}
            sm={3}
            item
            classes={{ root: classes.DocumentContainerRow }}
          >
            <Typography color="primary">性別:</Typography>
            <Typography></Typography>
          </Grid>
          <Grid
            xs={6}
            sm={3}
            item
            classes={{ root: classes.DocumentContainerRow }}
          >
            <Typography color="primary">電話(1):</Typography>
            <Typography></Typography>
          </Grid>
          <Grid
            xs={6}
            sm={3}
            item
            classes={{ root: classes.DocumentContainerRow }}
          >
            <Typography color="primary">電話(2):</Typography>
            <Typography></Typography>
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid
            xs={6}
            sm={3}
            item
            classes={{ root: classes.DocumentContainerRow }}
          >
            <Typography color="primary">LINE:</Typography>
            <Typography></Typography>
          </Grid>
          <Grid
            xs={6}
            sm={3}
            item
            classes={{ root: classes.DocumentContainerRow }}
          >
            <Typography color="primary">微信:</Typography>
            <Typography></Typography>
          </Grid>
          <Grid
            xs={12}
            sm={3}
            item
            classes={{ root: classes.DocumentContainerRow }}
          >
            <Typography color="primary">電子信箱:</Typography>
            <Typography></Typography>
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardContent>
        <Grid xs={6} sm={2} item>
          <Typography>客戶(二)</Typography>
        </Grid>
        <Grid container spacing={1}>
          <Grid
            xs={6}
            sm={3}
            item
            classes={{ root: classes.DocumentContainerRow }}
          >
            <Typography color="primary">名字:</Typography>
            <Typography></Typography>
          </Grid>
          <Grid
            xs={6}
            sm={3}
            item
            classes={{ root: classes.DocumentContainerRow }}
          >
            <Typography color="primary">性別:</Typography>
            <Typography></Typography>
          </Grid>
          <Grid
            xs={6}
            sm={3}
            item
            classes={{ root: classes.DocumentContainerRow }}
          >
            <Typography color="primary">電話(1):</Typography>
            <Typography></Typography>
          </Grid>
          <Grid
            xs={6}
            sm={3}
            item
            classes={{ root: classes.DocumentContainerRow }}
          >
            <Typography color="primary">電話(2):</Typography>
            <Typography></Typography>
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid
            xs={6}
            sm={3}
            item
            classes={{ root: classes.DocumentContainerRow }}
          >
            <Typography color="primary">LINE:</Typography>
            <Typography></Typography>
          </Grid>
          <Grid
            xs={6}
            sm={3}
            item
            classes={{ root: classes.DocumentContainerRow }}
          >
            <Typography color="primary">微信:</Typography>
            <Typography></Typography>
          </Grid>
          <Grid
            xs={12}
            sm={3}
            item
            classes={{ root: classes.DocumentContainerRow }}
          >
            <Typography color="primary">電子信箱:</Typography>
            <Typography></Typography>
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardContent>
        <Grid
          xs={6}
          sm={4}
          item
          classes={{ root: classes.DocumentContainerRow }}
        >
          <Typography color="primary">地址:</Typography>
          <Typography></Typography>
        </Grid>
      </CardContent>
      <Divider />
      <CardContent>
        <Grid container spacing={1}>
          <Grid
            xs={6}
            sm={2}
            item
            classes={{ root: classes.DocumentContainerRow }}
          >
            <Typography color="primary">建檔日期:</Typography>
            <Typography></Typography>
          </Grid>
          <Grid
            xs={6}
            sm={2}
            item
            classes={{ root: classes.DocumentContainerRow }}
          >
            <Typography color="primary">來源:</Typography>
            <Typography></Typography>
          </Grid>
          <Grid
            xs={6}
            sm={2}
            item
            classes={{ root: classes.DocumentContainerRow }}
          >
            <Typography color="primary">業務員:</Typography>
            <Typography></Typography>
          </Grid>
          <Grid
            xs={6}
            sm={2}
            item
            classes={{ root: classes.DocumentContainerRow }}
          >
            <Typography color="primary">意願指數:</Typography>
            <Typography></Typography>
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardContent>
        <Grid container spacing={1}>
          <Grid
            xs={6}
            sm={2}
            item
            classes={{ root: classes.DocumentContainerRow }}
          >
            <Typography color="primary">上課訂金:</Typography>
            <Typography></Typography>
          </Grid>
          <Grid
            xs={6}
            sm={2}
            item
            classes={{ root: classes.DocumentContainerRow }}
          >
            <Typography color="primary">上課收訂日期:</Typography>
            <Typography></Typography>
          </Grid>
          <Grid
            xs={6}
            sm={2}
            item
            classes={{ root: classes.DocumentContainerRow }}
          >
            <Typography color="primary">加盟訂金:</Typography>
            <Typography></Typography>
          </Grid>
          <Grid
            xs={6}
            sm={2}
            item
            classes={{ root: classes.DocumentContainerRow }}
          >
            <Typography color="primary">加盟收訂日期:</Typography>
            <Typography></Typography>
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardContent>
        <Typography color="primary">備註:</Typography>
        <Typography></Typography>
      </CardContent>
      <Divider />
      <CardContent>
        <Grid
          container
          spacing={1}
          classes={{ root: classes.DocumentContainerBetween }}
        >
          <Typography style={{ fontSize: 25 }}>追蹤紀錄</Typography>
          <Grid
            xs={12}
            sm={4}
            item
            classes={{ root: classes.DocumentContainerButtonEnd }}
          >
            <Button
              size="small"
              color="primary"
              variant="contained"
              fullWidth
              onPress={() => {}}
            >
              報名上課
            </Button>
            {"\u2002"}
            <Button
              size="small"
              color="primary"
              variant="contained"
              fullWidth
              onPress={() => {}}
            >
              新增追蹤
            </Button>
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardContent>
        <Table
          data={data}
          tableWidth={2}
          header={[
            "追蹤日期",
            "預約日期",
            "客戶姓名",
            "追蹤狀態",
            "追蹤內容",
            "追蹤業務",
          ]}
          columns={[
            (item) => <Text>{item.code}</Text>,
            (item) => <Text>{item.numberDebtor}</Text>,
            (item) => <Text>{item.address}</Text>,
            (item) => <Text>{item.date}</Text>,
            (item) => <Text>{item.status}</Text>,
            (item) => <Text>{item.floor}</Text>,
            (item) => <Text>{item.floorMillion}</Text>,
          ]}
        />
      </CardContent>
      <CardActions>
        <PageItem
          data={newData.pageArray}
          page={newData.page}
          onChangePage={(e) => changeData("page", e, true)}
        />
      </CardActions>
      <Divider />
      {simulationQuery?.attributes === "法拍" ? (
        <>
          <CardContent>
            <Typography style={{ fontSize: 25 }}>客戶需求</Typography>
          </CardContent>
          <Divider />
          <CardContent>
            <Grid container spacing={1}>
              <Grid
                xs={6}
                sm={2}
                item
                classes={{ root: classes.DocumentContainerRow }}
              >
                <Typography color="primary">需求區域:</Typography>
                <Typography></Typography>
              </Grid>
              <Grid
                xs={6}
                sm={2}
                item
                classes={{ root: classes.DocumentContainerRow }}
              >
                <Typography color="primary">需求屋型:</Typography>
                <Typography></Typography>
              </Grid>
              <Grid
                xs={6}
                sm={2}
                item
                classes={{ root: classes.DocumentContainerRow }}
              >
                <Typography color="primary">需求價格:</Typography>
                <Typography></Typography>
              </Grid>
              <Grid
                xs={6}
                sm={2}
                item
                classes={{ root: classes.DocumentContainerRow }}
              >
                <Typography color="primary">需求地坪:</Typography>
                <Typography></Typography>
              </Grid>
              <Grid
                xs={6}
                sm={2}
                item
                classes={{ root: classes.DocumentContainerRow }}
              >
                <Typography color="primary">需求建坪:</Typography>
                <Typography></Typography>
              </Grid>
              <Grid
                xs={6}
                sm={2}
                item
                classes={{ root: classes.DocumentContainerRow }}
              >
                <Typography color="primary">點交狀況:</Typography>
                <Typography></Typography>
              </Grid>
            </Grid>
          </CardContent>
          <Divider />
          <CardContent>
            <Grid container spacing={1}>
              <Grid
                xs={6}
                sm={2}
                item
                classes={{ root: classes.DocumentContainerRow }}
              >
                <Typography color="primary">案名:</Typography>
                <Typography></Typography>
              </Grid>
              <Grid
                xs={6}
                sm={2}
                item
                classes={{ root: classes.DocumentContainerRow }}
              >
                <Typography color="primary">電梯:</Typography>
                <Typography></Typography>
              </Grid>
              <Grid
                xs={6}
                sm={2}
                item
                classes={{ root: classes.DocumentContainerRow }}
              >
                <Typography color="primary">樓層:</Typography>
                <Typography></Typography>
              </Grid>
              <Grid
                xs={6}
                sm={2}
                item
                classes={{ root: classes.DocumentContainerRow }}
              >
                <Typography color="primary">房數:</Typography>
                <Typography></Typography>
              </Grid>
              <Grid
                xs={6}
                sm={2}
                item
                classes={{ root: classes.DocumentContainerRow }}
              >
                <Typography color="primary">屋況:</Typography>
                <Typography></Typography>
              </Grid>
            </Grid>
          </CardContent>
          <Divider />
          <CardContent>
            <Grid container spacing={1}>
              <Grid
                xs={6}
                sm={2}
                item
                classes={{ root: classes.DocumentContainerRow }}
              >
                <Typography color="primary">車位:</Typography>
                <Typography></Typography>
              </Grid>
              <Grid
                xs={6}
                sm={2}
                item
                classes={{ root: classes.DocumentContainerRow }}
              >
                <Typography color="primary">管理員:</Typography>
                <Typography></Typography>
              </Grid>
              <Grid
                xs={6}
                sm={2}
                item
                classes={{ root: classes.DocumentContainerRow }}
              >
                <Typography color="primary">管理費:</Typography>
                <Typography></Typography>
              </Grid>
            </Grid>
          </CardContent>
          <Divider />
          <CardContent>
            <Typography color="primary">概述:</Typography>
            <Typography></Typography>
          </CardContent>
          <Divider />
          <CardContent>
            <Grid
              container
              spacing={1}
              classes={{ root: classes.DocumentContainerBetween }}
            >
              <Typography style={{ fontSize: 25 }}>物件鎖定</Typography>
              <Grid
                xs={12}
                sm={4}
                item
                classes={{ root: classes.DocumentContainerButtonEnd }}
              >
                <Button
                  size="small"
                  color="primary"
                  variant="contained"
                  fullWidth
                  onPress={() => {}}
                >
                  新增物件鎖定
                </Button>
                {"\u2002"}
                <Button
                  size="small"
                  color="primary"
                  variant="contained"
                  fullWidth
                  onPress={() => {}}
                >
                  移除物件鎖定
                </Button>
              </Grid>
            </Grid>
          </CardContent>
          <Divider />
          <CardContent>
            <Table
              data={data}
              tableWidth={2}
              header={[
                "編號",
                "案號\n債務人",
                "大樓案名\n門牌地址",
                "日期\n時間",
                "類別\n狀況",
                "建坪\n地坪",
                "建坪／萬\n地坪／萬",
                "拍賣底價\n保證金",
                "拍次\n點交",
              ]}
              columns={[
                (item) => <Text>{item.code}</Text>,
                (item) => <Text>{item.numberDebtor}</Text>,
                (item) => <Text>{item.address}</Text>,
                (item) => <Text>{item.date}</Text>,
                (item) => <Text>{item.status}</Text>,
                (item) => <Text>{item.floor}</Text>,
                (item) => <Text>{item.floorMillion}</Text>,
              ]}
            />
          </CardContent>
          <CardActions>
            <PageItem
              data={newData.pageArray}
              page={newData.page}
              onChangePage={(e) => changeData("page", e, true)}
            />
          </CardActions>
          <Divider />
          <CardContent>
            <Typography style={{ fontSize: 25 }}>配對物件</Typography>
          </CardContent>
          <Divider />
          <CardContent>
            <Table
              data={data}
              tableWidth={2}
              header={[
                "無Email可寄送",
                "案號\n債務人",
                "大樓案名\n門牌地址",
                "日期\n時間",
                "類別\n狀況",
                "建坪\n地坪",
                "建坪／萬\n地坪／萬",
                "拍賣底價\n保證金",
                "拍次\n點交",
              ]}
              columns={[
                (item) => <Text>{item.code}</Text>,
                (item) => <Text>{item.numberDebtor}</Text>,
                (item) => <Text>{item.address}</Text>,
                (item) => <Text>{item.date}</Text>,
                (item) => <Text>{item.status}</Text>,
                (item) => <Text>{item.floor}</Text>,
                (item) => <Text>{item.floorMillion}</Text>,
              ]}
            />
          </CardContent>
          <CardActions>
            <PageItem
              data={newData.pageArray}
              page={newData.page}
              onChangePage={(e) => changeData("page", e, true)}
            />
          </CardActions>
        </>
      ) : null}
    </Card>
  );
}
